import React from 'react';
import './BlogSection.css';

const blogPosts = [
  {
    title: 'Gold: The Timeless Investment',
    date: 'June 22, 2024',
    excerpt: 'In a world where financial markets are unpredictable and economic uncertainties loom large, gold stands out as a beacon of stability and security. For millennia, gold has been treasured not just for its beauty but also for its intrinsic value...',
    image: 'https://spinellejewelry.com/cdn/shop/articles/1701977295021.png?v=1719043086&width=750' // Replace with your own images
  },
   {
    title: 'Natural Diamonds: The Real Best Choice for Diamonds',
    date: 'June 22, 2024',
    excerpt: 'When it comes to diamonds, few gems capture the imagination and desire quite like the natural diamond. Renowned for their unparalleled beauty, rarity, and enduring value, natural diamonds are more than just..',
    image: 'https://spinellejewelry.com/cdn/shop/articles/Buying_Natural_vs._Synthetic_Diamonds-2.jpg?v=1719043043&width=750' // Replace with your own images
  },
  {
    title: 'Gold: The Timeless Investment',
    date: 'June 22, 2024',
    excerpt: 'In a world where financial markets are unpredictable and economic uncertainties loom large, gold stands out as a beacon of stability and security. For millennia, gold has been treasured not just for its beauty but also for its intrinsic value...',
    image: 'https://spinellejewelry.com/cdn/shop/articles/1701977295021.png?v=1719043086&width=750' // Replace with your own images
  },

  // Add more posts here if needed
];

const HomeBlogSection = () => {
  return (
    <section className="home-blog-section">
      <h2 className="blog-section-title">Latest from Our Blog</h2>
      <div className="blog-posts-wrapper">
        {blogPosts.map((post, index) => (
          <div className="blog-card">
            
 <div className="blog-image">
              <img src={post.image} alt={post.title} />
            </div>
  <div className="blog-content">
    <h3>Gold: The Timeless Investment</h3>
    <p className="blog-date">June 22, 2024</p>
    <p className="blog-snippet">
      In a world where financial markets are unpredictable and economic uncertainties loom large, gold stands out as a beacon of stability and security...
    </p>
  </div>
  <a href="#" className="read-more">Read More →</a>
</div>

        ))}
      </div>
    </section>
  );
};

export default HomeBlogSection;
